/**
 * @author David Oravec<xorave06@stud.fit.vutbr.cz>
 */
import React from 'react';
import {Grid, Typography} from "@mui/material";
import ChangeForm from "./ChangeForm";

function ProfileView(props) {
    const {user, changeEmailOld, changeEmailNew, changeEmailNewAgain, submittingEmail, submitChangeEmail,
        changePasswordOld, changePasswordNew, changePasswordNewAgain, submittingPassword, submitChangePassword,
        emailErrors, passwordErrors, emailValues, passwordValues,emailSubmitInfo, passwordSubmitInfo
    } = props
    return (
        <div>
            <Grid container alignItems={"center"} justifyContent={"center"}>
                <Grid item xs={12}><Typography textAlign={"center"} variant={"h2"} component={"h2"}>
                    Ahoj {user.name}
                </Typography></Grid>
                <Grid item xs={12} md={6}>
                    <ChangeForm what={"email"}
                                whatText={"Email"}
                                setOld={changeEmailOld}
                                setNew={changeEmailNew}
                                setNewAgain={changeEmailNewAgain}
                                submit={submitChangeEmail}
                                isSubmited={submittingEmail}
                                oldText={"Aktuálny Email"}
                                newText={"Nový Email"}
                                newTextAgain={"Nový Email Znova"}
                                errors={emailErrors}
                                helperTextNew={"Email nemá správny formát!"}
                                helperTextAgain={"Emaily sa nezhodujú!"}
                                values={{old: emailValues.oldEmail, new: emailValues.newEmail, newAgain: emailValues.newEmailAgain}}
                                submitInfo={emailSubmitInfo}

                    />

                </Grid>
                <Grid item xs={12} md={6}>
                    <ChangeForm what={"password"}
                                whatText={"Heslo"}
                                setOld={changePasswordOld}
                                setNew={changePasswordNew}
                                setNewAgain={changePasswordNewAgain}
                                submit={submitChangePassword}
                                isSubmited={submittingPassword}
                                oldText={"Aktuálne Heslo"}
                                newText={"Nové Heslo"}
                                newTextAgain={"Nové Heslo Znova"}
                                errors={passwordErrors}
                                helperTextNew={"Heslo musí obsahovať špeciálny znak, číslo, písmeno(veľké, malé) a byť aspoň 8 znakov dlhé"}
                                helperTextAgain={"Heslá sa nezhodujú!"}
                                values={{old: passwordValues.oldPassword, new: passwordValues.password, newAgain: passwordValues.passwordAgain}}
                                submitInfo={passwordSubmitInfo}
                    />
                </Grid>
            </Grid>
        </div>
    );
}

export default ProfileView;